import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { getAzureAuthBrandName, getAzureAuthClientId, getAzureAuthDomain, getAzureAuthInstance, getAzureAuthSignUpSignInPolicy } from './Environment';
var appSettings = {
    AzureAdB2C: {
        Instance: getAzureAuthInstance(),
        ClientId: getAzureAuthClientId(),
        Domain: getAzureAuthDomain(),
        SignUpSignInPolicy: getAzureAuthSignUpSignInPolicy()
    },
    MSAL: {
        RedirectUri: '/',
        PostLogoutRedirectUri: '/user',
        CacheLocation: 'sessionStorage',
        StoreAuthStateInCookie: false
    }
};
// Set this here to be referenced in b2cPolicies
var authorityBaseAddress = appSettings.AzureAdB2C.Instance + '/' + appSettings.AzureAdB2C.Domain;
/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */ export var b2cPolicies = {
    names: {
        signUpSignIn: appSettings.AzureAdB2C.SignUpSignInPolicy
    },
    authorities: {
        signUpSignIn: {
            authority: authorityBaseAddress + '/' + appSettings.AzureAdB2C.SignUpSignInPolicy
        }
    },
    authorityDomain: appSettings.AzureAdB2C.Domain,
    authorityBaseAddress: authorityBaseAddress
};
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */ export var msalConfig = {
    auth: {
        clientId: appSettings.AzureAdB2C.ClientId,
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [
            b2cPolicies.authorityDomain,
            b2cPolicies.authorityBaseAddress
        ],
        redirectUri: appSettings.MSAL.RedirectUri,
        postLogoutRedirectUri: appSettings.MSAL.PostLogoutRedirectUri,
        navigateToLoginRequestUrl: false // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: appSettings.MSAL.CacheLocation,
        storeAuthStateInCookie: appSettings.MSAL.StoreAuthStateInCookie // Set this to "true" if you are having issues on IE11 or Edge
    }
};
/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */ export var msalLoginRequest = {
    scopes: [],
    extraQueryParameters: {
        otpUsage: 'never',
        brandUsage: getAzureAuthBrandName()
    }
};
var msalInstanceApplication = new PublicClientApplication(msalConfig);
var setDefaultActiveAccount = function setDefaultActiveAccount() {
    // Default to using the first account if no account is active on page load
    if (!msalInstanceApplication.getActiveAccount() && msalInstanceApplication.getAllAccounts().length > 0) {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        msalInstanceApplication.setActiveAccount(msalInstanceApplication.getAllAccounts()[0]);
    }
};
export var isSuccessEvent = function isSuccessEvent(event) {
    return event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS || event.eventType === EventType.SSO_SILENT_SUCCESS;
};
var registerMsalEventCallbacks = function registerMsalEventCallbacks() {
    msalInstanceApplication.addEventCallback(function(event) {
        if (isSuccessEvent(event) && event.payload) {
            var authenticationResult = event.payload;
            var account = authenticationResult.account;
            msalInstanceApplication.setActiveAccount(account);
        }
    });
};
export var msalInitializePromise = msalInstanceApplication.initialize().then(function() {
    registerMsalEventCallbacks();
}).then(function() {
    setDefaultActiveAccount();
}).catch(function(error) {
    console.error(error);
    throw error;
});
export var msalInstance = msalInstanceApplication;
